import type { MenuItemControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/controls/Menu';
import { constructKeytip, getKeytipString } from 'owa-command-ribbon';
import { ControlInfo, getControlInfo } from 'owa-mail-ribbon-utils';
import { MailRibbonControlId, MailRibbonTabId } from 'owa-ribbon-ids';
import {
    onBlockClicked,
    onJunkNotJunkClicked,
    onMarkAsPhishingClicked,
} from '../../util/commandActions';
import { createMailAppButton } from '../../util/createMailRibbonButton';

export default function getJunkSections(
    keytipTabId: MailRibbonTabId | undefined,
    iconColor?: string
): MenuItemControlProps[] {
    const controls: MenuItemControlProps[] = [];

    let controlId: MailRibbonControlId = MailRibbonControlId.JunkNotJunk;
    let controlInfo: ControlInfo = getControlInfo(controlId);

    controls.push(
        createMailAppButton(
            controlId,
            controlInfo.text,
            controlInfo.tooltip,
            false /*isPopout*/,
            onJunkNotJunkClicked,
            constructKeytip(
                keytipTabId
                    ? [
                          getKeytipString(keytipTabId),
                          getKeytipString(MailRibbonControlId.JunkFlyout),
                      ]
                    : [getKeytipString(MailRibbonControlId.JunkFlyout)],
                getKeytipString(controlId)
            ),
            controlInfo.iconName,
            iconColor
        )
    );

    controlId = MailRibbonControlId.Phishing;
    controlInfo = getControlInfo(controlId);

    controls.push(
        createMailAppButton(
            controlId,
            controlInfo.text,
            controlInfo.tooltip,
            false /*isPopout*/,
            onMarkAsPhishingClicked,
            constructKeytip(
                keytipTabId
                    ? [
                          getKeytipString(keytipTabId),
                          getKeytipString(MailRibbonControlId.JunkFlyout),
                      ]
                    : [getKeytipString(MailRibbonControlId.JunkFlyout)],
                getKeytipString(controlId)
            ),
            controlInfo.iconName,
            iconColor
        )
    );

    controlId = MailRibbonControlId.Block;
    controlInfo = getControlInfo(controlId);

    controls.push(
        createMailAppButton(
            controlId,
            controlInfo.text,
            controlInfo.tooltip,
            false /*isPopout*/,
            onBlockClicked,
            constructKeytip(
                keytipTabId
                    ? [
                          getKeytipString(keytipTabId),
                          getKeytipString(MailRibbonControlId.JunkFlyout),
                      ]
                    : [getKeytipString(MailRibbonControlId.JunkFlyout)],
                getKeytipString(MailRibbonControlId.Block)
            ),
            controlInfo.iconName,
            iconColor
        )
    );

    return controls;
}
